export const PL = 'pl'
export const EN = 'en'

export const LANGS = {
  [PL]: '🇵🇱',
  [EN]: '🇬🇧',
}

export const TRANSLATIONS = {
  [PL]: {
    noFiltersLabel: 'Nie wybrano filtrów',
    errorLabel: 'Coś poszło nie tak...',
    tryAgainLabel: 'Ponów',
    salaryPerHourLabel: 'na godzinę',
    employmentTypeLabel: 'Wybierz formę zatrudnienia',
    measuresLabel: 'Wybierz miary',
    salaryRangesLabel: 'Wybierz zakres zarobków',
    submitButtonLabel: 'Porównaj',
    dataGeneratedLabel: 'Dane wygenerowano',
    contractOfEmploymentLabel: 'Umowa o pracę - KUP',
    contractOfEmploymentLegendLabel: 'UoP - KUP',
    contractOfEmploymentEmployerCostLabel: 'UoP - koszty pracodawcy',
    contractOfEmploymentEmployerCostNewDealLabel: 'UoP NŁ - koszty pracodawcy',
    contractOfEmploymentShortLabel: 'UoP',
    lowZusLabel: 'mały ZUS',
    highZusLabel: 'duży ZUS',
    averageLabel: 'Średnia',
    sumLabel: 'Suma',
    grossLabel: 'Brutto',
    additionalFiltersLabel: 'Dodatkowe opcje',
    showEmployerCostLabel: 'Koszty pracodawcy',
    showTaxesLabel: 'Podatki',
    taxLabelSuffix: 'podatki',
    before2022Label: 'Przed 2022',
    before2022ShortLabel: '<2022',
    newDealLabel: 'Nowy ład',
    newDealShortLabel: 'NŁ',
    autocompletePlaceholder: 'Wybierz do %s opcji',
  },
  [EN]: {
    noFiltersLabel: 'No filters selected',
    errorLabel: 'Something went wrong...',
    tryAgainLabel: 'Try again',
    salaryPerHourLabel: 'per hour',
    employmentTypeLabel: 'Choose types of employment',
    measuresLabel: 'Choose measures',
    salaryRangesLabel: 'Choose gross ranges',
    submitButtonLabel: 'Compare',
    dataGeneratedLabel: 'Data generated at',
    contractOfEmploymentLabel: 'CoE - CR',
    contractOfEmploymentLegendLabel: 'CoE - KUP',
    contractOfEmploymentEmployerCostLabel: 'CoE - employer cost',
    contractOfEmploymentEmployerCostNewDealLabel: 'CoE ND - employer cost',
    contractOfEmploymentShortLabel: 'CoE',
    lowZusLabel: 'low ZUS',
    highZusLabel: 'high ZUS',
    averageLabel: 'Avg',
    sumLabel: 'Sum',
    grossLabel: 'Gross',
    additionalFiltersLabel: 'Additional options',
    showEmployerCostLabel: 'Employer costs',
    showTaxesLabel: 'Taxes',
    taxLabelSuffix: 'taxes',
    before2022Label: 'before 2022',
    before2022ShortLabel: '<2022',
    newDealLabel: 'New Deal',
    newDealShortLabel: 'ND',
    autocompletePlaceholder: 'Choose up to %s options',
  },
}
